import { useQuery } from '@apollo/client';
import { gql } from '__generated__';
import { DivisionType } from '__generated__/graphql';
import { FC, useState } from 'react';
import { useParams } from 'react-router-dom';

import DataTable from 'components/DataTable';
import ErrorMessage from 'components/ErrorMessage';
import LoadingIndicator from 'components/LoadingIndicator';

import CreateDivisionDialogButton from './CreateDivisionDialogButton';
import UpdateDivisionDialog from './UpdateDivisionDialog';

const DivisionS_QUERY = gql(`
  query Divisions($departmentId: ID!) {
    department(id: $departmentId) {
      id
      divisions {
        id
        name
        shortName
        employeeCount
        createdAt
      }
    }
  }
`);

const DivisionsPage: FC = () => {
  const { departmentId } = useParams<{ departmentId: string }>();
  const [divisionOnDisplay, setDivisionOnDisplay] = useState<DivisionType | null>(null);

  const { loading, error, data, refetch } = useQuery(DivisionS_QUERY, {
    variables: {
      departmentId: departmentId as string,
    },
    nextFetchPolicy: 'network-only', // This ensures empolyee count is up to date
  });
  if (loading) return <LoadingIndicator />;

  if (error || !data) return <ErrorMessage error={error} refetch={refetch} />;

  const divisions = data.department.divisions;

  return (
    <>
      <CreateDivisionDialogButton />
      {divisionOnDisplay ? (
        <UpdateDivisionDialog
          id={divisionOnDisplay.id}
          name={divisionOnDisplay.name}
          shortName={divisionOnDisplay.shortName ?? ''}
          onClose={() => setDivisionOnDisplay(null)}
        />
      ) : null}
      <DataTable
        data={divisions as DivisionType[]}
        onClick={division => setDivisionOnDisplay(division)}
        columns={[
          {
            label: 'Division Name',
            fieldName: 'name',
          },
          {
            label: 'Short Name',
            fieldName: 'shortName',
          },
          {
            label: 'Employee Count',
            fieldName: 'employeeCount',
          },
          {
            label: 'Created At',
            fieldName: 'createdAt',
          },
        ]}
      />
    </>
  );
};

export default DivisionsPage;
